<template>
  <div>

    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <div v-if="current_champ.nom == 'regles_or_ffco'">
      <div class="text-blue font-weight-bold">Consulter les <a class="text-blue text-decoration-underline"
          href="https://www.ffcorientation.fr/media/cms_page_media/74/10REGLESDOR.pdf" target="_blank">Règles OR
          FFCO</a></div>
    </div>
    <v-select :items="items" v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-select>
  </div>
</template>

<script>
export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
      items: [
        { title: "Sélectionner", value: "" },
        { title: "0ui", value: 1 },
        { title: "Non", value: 0 },
      ],
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
  },

  created() {
    this.current_champ = this.champ;
    if (this.current_champ.value == "1") {
      this.current_champ.value = 1;
    } else if (this.current_champ.value == "0") {
      this.current_champ.value = 0;
    } else {
      this.current_champ.value = "";
    }
  },
};
</script>

<style lang="scss">
.v-autocomplete__content {
  max-height: 300px !important;
  min-height: auto !important;
}
</style>